module.exports = __webpack_public_path__ + "fonts/LetteraTextLLWeb-Bold.9d4feb7.woff2";